/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
export class Location {
  locationId: number;
  locationName: string;
  siteId: number;
  siteName: string;
  locationTypeId: number;
  active: boolean;
  violationId:number;
}
